exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.responsive-items {\n  display: flex;\n  flex-grow: 1;\n}\n.responsive-wrapper {\n  display: flex;\n  flex-grow: 1;\n}\n", ""]);

// exports
